import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PageContainer, { Wrap } from 'components/PageContainer';
import Layout from 'components/Layout';
import PageTitle from 'components/PageTitle';
import ListCards from 'components/ListCards';
import Markup from 'components/Markup';
import prismic from '../prismic';
import Prismic from 'prismic-javascript';
import { fetchRankings } from 'actions/rankings';
import { fetchPrismicWijzers } from 'actions/prismic';

class Wijzers extends Component {
  static async getInitialProps({ store, req, lang, query }) {
    store.dispatch(fetchRankings({ per_page: 50, lang }));
    return store.dispatch(
      fetchPrismicWijzers({
        lang,
        orderings: '[my.wijzer.published_date desc]',
        fieldQuery: Prismic.Predicates.at('my.wijzer.disabled', 'No'),
        pageSize: 50
      })
    );
  }

  render() {
    const {
      rankings: { items: qmItems },
      wijzers,
      ...rest
    } = this.props;
    const { meta, description, results: prismicItems } = prismic.wijzers(
      wijzers
    );
    const cardItems = [...qmItems, ...prismicItems].map((item) => ({
      url: item.url,
      name: item.title,
      published_on: item.updated_on,
      cover_image: item.cover_image_url.medium
    }));

    return (
      <Layout meta={meta} dept="ranking" {...rest}>
        <PageContainer>
          <PageTitle>{meta.title}</PageTitle>
          <Wrap>
            <Markup intro>{description}</Markup>
            <ListCards items={cardItems} />
          </Wrap>
        </PageContainer>
        <br />
      </Layout>
    );
  }
}

Wijzers.propTypes = {
  rankings: PropTypes.object,
  wijzers: PropTypes.object
};

export default connect(({ rankings, prismic }) => ({
  rankings,
  wijzers: prismic.wijzers
}))(Wijzers);
